import { render, staticRenderFns } from "./ReportFooter.vue?vue&type=template&id=cd77d0d2&"
import script from "./ReportFooter.vue?vue&type=script&lang=js&"
export * from "./ReportFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports